var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileSup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8877 22.3446C34.5261 22.5059 34.25 22.8602 34.25 23.3284V27.6722C34.25 28.2675 34.7325 28.75 35.3278 28.75H39.6716C40.1117 28.75 40.4512 28.506 40.6243 28.1764C40.7071 28.479 40.75 28.7937 40.75 29.1126V37.34C40.75 39.3006 39.1606 40.89 37.2 40.89H26.8C24.8394 40.89 23.25 39.3006 23.25 37.34V25.8C23.25 23.8394 24.8394 22.25 26.8 22.25H34.0737C34.3502 22.25 34.6232 22.2822 34.8877 22.3446ZM35.75 27.25V24.3478L38.6522 27.25H35.75Z",
    fill: "#6673BD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSup);
export default __webpack_public_path__ + "static/media/file_sup.6bad5d1ec2ebb5a1b5574f845b253713.svg";
export { ForwardRef as ReactComponent };